import React from 'react';
export class CnListProItemBottomArea extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemBottomArea.displayName = 'CnListProItemBottomArea';
